// extracted by mini-css-extract-plugin
module.exports = {"hora":"Horario_hora__2gHwB"};